// extracted by mini-css-extract-plugin
export default {"header":"Header_header__CzSo+","scrolled":"Header_scrolled__de2HJ"};